import {encrypt} from 'utils/encryption.utils'
import {createDocument} from 'utils/db.utils'
import {getCurrentUserId} from 'utils/user.utils'

export default async function({keyManager, roomId, msg, from}) {
  if (!keyManager || !roomId || !msg) return null

  if (!from) {
    from = {}
  }

  if (!from.name) {
    from.name = require('./storage.utils').getName(roomId) || null
  }

  if (!from.uid) {
    from.uid = getCurrentUserId() || null
  }

  const message = await encrypt({keyManager, msg})
  const createdDocument = await createDocument(`chats/${roomId}/messages`, {
    message,
    from,
  })

  return createdDocument
}
